import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: '0101', label: 'Te Aupōuri (0101)' },
    { value: '0102', label: 'Ngāti Kahu (0102)' },
    { value: '0103', label: 'Ngāti Kurī (0103)' },
    { value: '0104', label: 'Ngāpuhi (0104)' },
    {
      value: '0105',
      label: 'Ngāpuhi ki Whaingaroa-Ngāti Kahu ki Whaingaroa (0105)',
    },
    { value: '0106', label: 'Te Rarawa (0106)' },
    { value: '0107', label: 'Ngāi Takoto (0107)' },
    { value: '0108', label: 'Ngāti Wai (0108)' },
    { value: '0109', label: 'Ngāti Whātua (not Ōrākei or Kaipara) (0109)' },
    { value: '0110', label: 'Te Kawerau ā Maki (0110)' },
    { value: '0111', label: 'Te Uri-o-Hau (0111)' },
    { value: '0112', label: 'Te Roroa (0112)' },
    { value: '0113', label: 'Ngāti Whātua o Kaipara (0113)' },
    { value: '0114', label: 'Ngāti Whātua o Ōrākei (0114)' },
    { value: '0115', label: 'Ngāi Tai ki Tāmaki (0115)' },
    { value: '0116', label: 'Ngāti Hine (Te Tai Tokerau) (0116)' },
    { value: '0117', label: 'Te Paatu (0117)' },
    { value: '0118', label: 'Ngāti Manuhiri (0118)' },
    { value: '0119', label: 'Ngāti Rehua (0119)' },
    { value: '0120', label: 'Ngāti Torehina ki Mata-ure ō Hau (0120)' },
    { value: '0121', label: 'Ngāti Kahu ki Whangaroa (0121)' },
    { value: '0201', label: 'Ngāti Hako (0201)' },
    { value: '0202', label: 'Ngāti Hei (0202)' },
    { value: '0203', label: 'Ngāti Maru (Hauraki) (0203)' },
    { value: '0204', label: 'Ngāti Paoa (0204)' },
    { value: '0205', label: 'Patukirikiri (0205)' },
    { value: '0206', label: 'Ngāti Porou ki Harataunga ki Mataora (0206)' },
    { value: '0207', label: 'Ngāti Pūkenga ki Waiau (0207)' },
    { value: '0208', label: 'Ngāti Rāhiri Tumutumu (0208)' },
    { value: '0210', label: 'Ngāti Tamaterā (0210)' },
    { value: '0211', label: 'Ngāti Tara Tokanui (0211)' },
    { value: '0212', label: 'Ngāti Whanaunga (0212)' },
    { value: '0213', label: 'Ngāti Huarere (0213)' },
    { value: '0301', label: 'Ngāti Haua (Waikato) (0301)' },
    { value: '0302', label: 'Ngāti Maniapoto (0302)' },
    { value: '0303', label: 'Raukawa (Waikato) (0303)' },
    { value: '0304', label: 'Waikato (0304)' },
    { value: '0305', label: 'Ngāti Te Ata (0305)' },
    { value: '0306', label: 'Ngāti Hikairo (0306)' },
    { value: '0307', label: 'Rereahu (0307)' },
    { value: '0308', label: 'Ngāti Tiipa (0308)' },
    { value: '0309', label: 'Ngāti Korokī Kahukura (0309)' },
    { value: '0310', label: 'Ngāti Tamaoho (0310)' },
    { value: '0311', label: 'Te Ākitai-Waiohua (0311)' },
    { value: '0312', label: 'Tainui Awhiro (0312)' },
    { value: '0313', label: 'Ngāti Hinerangi (0313)' },
    { value: '0401', label: 'Ngāti Pikiao (Te Arawa) (0401)' },
    { value: '0402', label: 'Ngāti Rangiteaorere (Te Arawa) (0402)' },
    { value: '0403', label: 'Ngāti Rangitihi (Te Arawa) (0403)' },
    { value: '0404', label: 'Ngāti Rangiwewehi (Te Arawa) (0404)' },
    { value: '0405', label: 'Tapuika (Te Arawa) (0405)' },
    { value: '0406', label: 'Ngāti Tarāwhai (Te Arawa) (0406)' },
    { value: '0407', label: 'Tūhourangi (Te Arawa) (0407)' },
    { value: '0408', label: 'Uenuku-Kōpako (Te Arawa) (0408)' },
    { value: '0409', label: 'Waitaha (Te Arawa) (0409)' },
    { value: '0410', label: 'Ngāti Whakaue (Te Arawa) (0410)' },
    { value: '0411', label: 'Ngāti Tūwharetoa (ki Taupō) (0411)' },
    { value: '0412', label: 'Ngāti Tahu-Ngāti Whaoa (Te Arawa) (0412)' },
    { value: '0413', label: 'Ngāti Mākino (0413)' },
    { value: '0414', label: 'Ngāti Kearoa / Ngāti Tuarā (0414)' },
    { value: '0415', label: 'Ngāti Rongomai (Te Arawa) (0415)' },
    { value: '0501', label: 'Ngāti Pūkenga (0501)' },
    { value: '0502', label: 'Ngāi Te Rangi (0502)' },
    { value: '0503', label: 'Ngāti Ranginui (0503)' },
    { value: '0504', label: 'Ngāti Awa (0504)' },
    { value: '0505', label: 'Ngāti Manawa (0505)' },
    { value: '0506', label: 'Ngāi Tai (Tauranga Moana/Mātaatua) (0506)' },
    { value: '0507', label: 'Tūhoe (0507)' },
    { value: '0508', label: 'Whakatōhea (0508)' },
    { value: '0509', label: 'Te Whānau-ā-Apanui (0509)' },
    { value: '0510', label: 'Ngāti Whare (0510)' },
    { value: '0511', label: 'Ngā Pōtiki ā Tamapahore (0511)' },
    { value: '0512', label: 'Te Upokorehe (0512)' },
    { value: '0513', label: 'Ngāti Tūwharetoa ki Kawerau (0513)' },
    { value: '0601', label: 'Ngāti Porou (0601)' },
    { value: '0602', label: 'Te Aitanga-a-Māhaki (0602)' },
    { value: '0603', label: 'Rongowhakaata (0603)' },
    { value: '0604', label: 'Ngāi Tāmanuhiri (0604)' },
    { value: '0605', label: 'Te Aitanga ā Hauiti (0605)' },
    { value: '0701', label: 'Rongomaiwahine (Te Māhia) (0701)' },
    { value: '0702', label: 'Ngāti Kahungunu ki Te Wairoa (0702)' },
    { value: '0703', label: 'Ngāti Kahungunu ki Heretaunga (0703)' },
    { value: '0704', label: 'Ngāti Kahungunu ki Wairarapa (0704)' },
    {
      value: '0706',
      label: "Rangitāne (Te Matau-a-Māui/Hawke's Bay/Wairarapa) (0706)",
    },
    { value: '0707', label: 'Ngāti Kahungunu ki Te Whanganui-a-Orotu (0707)' },
    { value: '0708', label: 'Ngāti Kahungunu ki Tamatea (0708)' },
    { value: '0709', label: 'Ngāti Kahungunu ki Tamakinui a Rua (0709)' },
    { value: '0710', label: 'Ngāti Pāhauwera (0710)' },
    { value: '0711', label: 'Ngāti Rākaipaaka (0711)' },
    { value: '0712', label: 'Ngāti Hineuru (0712)' },
    { value: '0713', label: 'Maungaharuru Tangitū (0713)' },
    { value: '0714', label: 'Rangitāne o Tamaki nui ā Rua (0714)' },
    { value: '0715', label: 'Ngāti Ruapani ki Waikaremoana (0715)' },
    { value: '0716', label: 'Te Hika o Pāpāuma (0716)' },
    { value: '0717', label: 'Ngāti Hinemanu (Heretaunga) (0717)' },
    { value: '0801', label: 'Te Atiawa (Taranaki) (0801)' },
    { value: '0802', label: 'Ngāti Maru (Taranaki) (0802)' },
    { value: '0803', label: 'Ngāti Mutunga (Taranaki) (0803)' },
    { value: '0804', label: 'Ngā Rauru (0804)' },
    { value: '0805', label: 'Ngāruahine (0805)' },
    { value: '0806', label: 'Ngāti Ruanui (0806)' },
    { value: '0807', label: 'Ngāti Tama (Taranaki) (0807)' },
    { value: '0808', label: 'Taranaki (0808)' },
    { value: '0809', label: 'Tangāhoe (0809)' },
    { value: '0810', label: 'Pakakohi (0810)' },
    { value: '0901', label: 'Ngā Wairiki Ngāti Apa (0901)' },
    { value: '0902', label: 'Te Ati Haunui-a-Pāpārangi (0902)' },
    { value: '0903', label: 'Ngāti Haua (Taumarunui) (0903)' },
    { value: '0904', label: 'Ngāti Hauiti (Rangitīkei) (0904)' },
    { value: '0905', label: 'Ngāti Whitikaupeka (Rangitīkei) (0905)' },
    { value: '0906', label: 'Ngāi Te Ohuake (Rangitīkei) (0906)' },
    { value: '0907', label: 'Ngāti Tamakōpiri (Rangitīkei) (0907)' },
    { value: '0908', label: 'Ngāti Rangi (Ruapehu, Whanganui) (0908)' },
    { value: '0909', label: 'Uenuku (Ruapehu, Waimarino) (0909)' },
    { value: '0910', label: 'Tamahaki (Ruapehu, Waimarino) (0910)' },
    { value: '0911', label: 'Tamakana (Ruapehu, Waimarino) (0911)' },
    { value: '0912', label: 'Ngāti Hinemanu (Rangitīkei) (0912)' },
    {
      value: '1001',
      label: 'Te Atiawa (Te Whanganui-a-Tara/Wellington) (1001)',
    },
    { value: '1002', label: 'Muaūpoko (1002)' },
    { value: '1003', label: 'Rangitāne (Manawatū) (1003)' },
    { value: '1004', label: 'Ngāti Raukawa (Horowhenua/Manawatū) (1004)' },
    {
      value: '1005',
      label: 'Ngāti Toarangatira (Te Whanganui-a-Tara/Wellington) (1005)',
    },
    { value: '1006', label: 'Te Atiawa ki Whakarongotai (1006)' },
    {
      value: '1007',
      label:
        'Ngāti Tama ki Te Upoko o Te Ika (Te Whanganui-a-Tara/Wellington) (1007)',
    },
    { value: '1008', label: 'Ngāti Kauwhata (1008)' },
    { value: '1009', label: 'Ngāti Tukorehe (1009)' },
    { value: '1101', label: 'Te Atiawa (Te Waipounamu/South Island) (1101)' },
    { value: '1102', label: 'Ngāti Koata (1102)' },
    { value: '1103', label: 'Ngāti Kuia (1103)' },
    { value: '1104', label: 'Kāti Māmoe (1104)' },
    { value: '1107', label: 'Rangitāne (Te Waipounamu/South Island) (1107)' },
    { value: '1108', label: 'Ngāti Rārua (1108)' },
    { value: '1109', label: 'Ngāi Tahu / Kāi Tahu (1109)' },
    { value: '1110', label: 'Ngāti Tama ki Te Tauihu (1110)' },
    {
      value: '1111',
      label: 'Ngāti Toarangatira (Te Waipounamu/South Island) (1111)',
    },
    { value: '1112', label: 'Waitaha (Te Waipounamu/South Island) (1112)' },
    { value: '1113', label: 'Ngāti Apa ki Te Rā Tō (1113)' },
    { value: '1201', label: 'Moriori (1201)' },
    {
      value: '1202',
      label: 'Ngāti Mutunga (Wharekauri/Chatham Islands) (1202)',
    },
    { value: '2001', label: 'Tainui, iwi not named (2001)' },
    { value: '2002', label: 'Te Arawa, iwi not named (2002)' },
    { value: '2003', label: 'Tākitimu, iwi not named (2003)' },
    { value: '2004', label: 'Aotea, iwi not named (2004)' },
    { value: '2005', label: 'Mātaatua, iwi not named (2005)' },
    { value: '2006', label: 'Mahuru, iwi not named (2006)' },
    { value: '2007', label: 'Māmari, iwi not named (2007)' },
    { value: '2008', label: 'Ngātokimatawhaorua, iwi not named (2008)' },
    { value: '2009', label: 'Nukutere, iwi not named (2009)' },
    { value: '2010', label: 'Tokomaru, iwi not named (2010)' },
    { value: '2011', label: 'Kurahaupō, iwi not named (2011)' },
    { value: '2012', label: 'Muriwhenua, iwi not named (2012)' },
    { value: '2013', label: 'Hauraki / Pare Hauraki, iwi not named (2013)' },
    { value: '2014', label: 'Tūranganui a Kiwa, iwi not named (2014)' },
    {
      value: '2015',
      label: 'Te Tauihu o Te Waka a Māui, iwi not named (2015)',
    },
    { value: '2016', label: 'Tauranga Moana, iwi not named (2016)' },
    { value: '2017', label: 'Horouta, iwi not named (2017)' },
    { value: '2018', label: 'Mōkai Pātea, iwi not named (2018)' },
    { value: '2101', label: 'Te Atiawa, region not known (2101)' },
    { value: '2102', label: 'Ngāti Haua, region not known (2102)' },
    { value: '2103', label: 'Ngāti Maru, region not known (2103)' },
    { value: '2104', label: 'Ngāti Mutunga, region not known (2104)' },
    { value: '2105', label: 'Rangitāne, region not known (2105)' },
    { value: '2106', label: 'Ngāti Raukawa, region not known (2106)' },
    { value: '2107', label: 'Ngāti Tama, region not known (2107)' },
    { value: '2108', label: 'Ngāti Toa, region not known (2108)' },
    { value: '2109', label: 'Waitaha, region not known (2109)' },
    { value: '2110', label: 'Ngāti Apa, region not known (2110)' },
    { value: '2111', label: 'Ngāi Tai, region not known (2111)' },
    { value: '2112', label: 'Ngāti Kahungunu, region not known (2112)' },
    { value: '2113', label: 'Ngāti Tūwharetoa, region not known (2113)' },
    { value: '2114', label: 'Ngāti Hinemanu, region not known (2114)' },
    { value: '2201', label: 'Hapū affiliated to more than one iwi (2201)' },
    {
      value: '2301',
      label: 'Te Tai Tokerau/Tāmaki-makaurau Region, Iwi not named (2301)',
    },
    { value: '2302', label: 'Hauraki Region, Iwi not named (2302)' },
    {
      value: '2303',
      label: 'Waikato/Te Rohe Pōtae Region, Iwi not named (2303)',
    },
    { value: '2304', label: 'Te Arawa/Taupō Region, Iwi not named (2304)' },
    {
      value: '2305',
      label: 'Tauranga Moana/Mātaatua Region, Iwi not named (2305)',
    },
    { value: '2306', label: 'Te Tai Rāwhiti Region, Iwi not named (2306)' },
    {
      value: '2307',
      label: 'Te Matau-a-Māui/Wairarapa Region, Iwi not named (2307)',
    },
    { value: '2308', label: 'Taranaki Region, Iwi not named (2308)' },
    {
      value: '2309',
      label: 'Whanganui/Rangitīkei Region, Iwi not named (2309)',
    },
    {
      value: '2310',
      label:
        'Manawatū/Horowhenua/Te Whanganui-a-Tara Region, Iwi not named (2310)',
    },
    { value: '2311', label: 'Te Waipounamu Region, Iwi not named (2311)' },
    {
      value: '2312',
      label: 'Rēkohu/Wharekauri Region, Imi/Iwi not named (2312)',
    },
    { value: '9999', label: 'Not Stated (9999)' },
  ],
});
